(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('OperatorService', OperatorService);

  OperatorService.$inject = ['$resource'];

  function OperatorService ($resource) {
    return $resource(apiUrl + '/operator/:id', { id: '@id' }, {
      operator: { method: 'GET', params: {}, isArray: false },
      token: { url: apiUrl + '/operator-token', method: 'POST', params: {}, isArray: false },
      resetToken: { url: apiUrl + '/reset-operator-token', method: 'POST', params: {}, isArray: false }

    });
  }
})();
